"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 * create an empty LevelLists
 */
function createLevelLists() {
    return {
        listsMetadata: {},
        currentUniqueListId: -1,
    };
}
exports.createLevelLists = createLevelLists;
//# sourceMappingURL=LevelLists.js.map